import type { BaseFieldObject } from '@noths/polaris-client-google-analytics';

type EventCategory = 'Product listings';

export type ProductClickTrackingEvent = {
  destination_URL?: string;
  ecommerce: {
    click: {
      actionField: {
        list: string;
      };
      products: BaseFieldObject[];
    };
  };
  event: 'product_clicks';
  event_action: 'Product Click';
  event_category: EventCategory;
  event_label: string;
};

interface GetProductClickTrackingEventArgs {
  actionFieldList: string;
  destinationUrl?: string;
  eventCategory: EventCategory;
  eventLabel: string;
  products: BaseFieldObject[];
}

export const getProductClickTrackingEvent = ({
  actionFieldList,
  destinationUrl,
  eventCategory,
  eventLabel,
  products,
}: GetProductClickTrackingEventArgs): ProductClickTrackingEvent => {
  return {
    event: 'product_clicks',
    event_category: eventCategory,
    event_action: 'Product Click',
    event_label: eventLabel,
    ...(destinationUrl ? { destination_URL: destinationUrl } : {}),
    ecommerce: {
      click: {
        actionField: {
          list: actionFieldList,
        },
        products,
      },
    },
  };
};
